import endpoints, { axios } from "../config/api";

function markNotificationAsRead(notificationId: number) {
  return axios.post(endpoints.account.markNotificationAsRead(notificationId));
}

export default markNotificationAsRead;
